module.exports = __webpack_public_path__ + "img/imgleftx25white.9649aedb.png";